import React, { useState } from 'react';

import { Formik } from 'formik';

import { Button, Form} from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Alert from '../helper/Alert';
import * as yup from 'yup';

const NewsletterOptOut = () => {
    const { request } = useRequest();
    const [done, setDone] = useState(false);

    const optOut = async () => {
        let result = await request("/User/OptOutOfNewsletter");
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                toast.error(json.message);
            }
            else {
                toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            }
        }
        else {
            setDone(true);
        }
    }
    if (done) {
        return (
            <Alert type="success" message="Die Erinnerungs-Mails wurden erfolgreich abbestellt." />
        )
    }
    return (
        <Formik
            validationSchema={yup.object().shape({})}
            onSubmit={() => {
                optOut();
            }}
            initialValues={{}}
        >
            {
                ({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => {
                    return (
                        <Form className="mt-3" noValidate onSubmit={handleSubmit}>
                            <p>Wenn Sie die Erinnerungs-Emails abbestellen, erhalten Sie keine Benachrichtigungen über anstehende Termine mehr.</p>
                            <p>Sie können dies im ihren Nutzereinstellungen rückgängig machen.</p>
                            <p>Klicken Sie zum Bestätigen den Button.</p>
                            <Button variant="primary" type="submit">
                                Terminerinnerungen abbestellen
                            </Button>
                        </Form>
                    );
                }
            }
        </Formik>
    )
}

export default NewsletterOptOut;